import React from "react";
import { Status } from "ui-kit-ck-consultant";

import { getValue } from "../../../utils/general";

export default class NPSSatisfaction extends React.Component {
  render() {
    let data = [0, 0, 0]; // [detractors, passives, promoters]
    if (this.props.data && this.props.data.length === 3) {
      data = this.props.data;
    }

    const total = data[0] + data[1] + data[2]; // inclure les passifs

    let score = 0;
    score += data[0] * -100;
    score += data[2] * 100;

    let result = 0;
    if (total > 0) {
      result = Math.round((score / total) * 100) / 100;
    }

    if (result > 0) {
      return (
        <Status
          className="bg-green white w-100 nowrap mb-10"
          style={{ fontSize: 14 }}
          text={`Résultat NPS ${this.props.isDay ? "du jour " : ""}: ${getValue(
            result
          )}`}
        />
      );
    } else if (result === 0) {
      return (
        <Status
          className="bg-orange white w-100 nowrap mb-10"
          style={{ fontSize: 14 }}
          text={`Résultat NPS ${this.props.isDay ? "du jour " : ""}: ${getValue(
            result
          )}`}
        />
      );
    } else if (result < 0) {
      return (
        <Status
          className="bg-red white w-100 nowrap mb-10"
          style={{ fontSize: 14 }}
          text={`Résultat NPS ${this.props.isDay ? "du jour " : ""}: ${getValue(
            result
          )}`}
        />
      );
    } else {
      return (
        <Status
          className="bg-blue white w-100 nowrap mb-10"
          style={{ fontSize: 14 }}
          text={`Résultat NPS ${
            this.props.isDay ? "du jour " : ""
          }: Aucune réponse`}
        />
      );
    }
  }
}
